import languageMap from 'sources/locale/en';
import React from "react";

const locFunction = (key) => {
    const maybeLocalizedString = languageMap[key];
    if (!maybeLocalizedString && __DEV__) {
        console.error(`Failed getting a localized string for the following key ${key}! 
Please provide localization for this key. Returning the unlocalized key.`);
    }

    return maybeLocalizedString || key;
};

export const JSXResolver = (str, ...args) => {
    const parts = str.split("%jsx");

    return parts.map((substr, i) =>
        <React.Fragment key={i}>
            {substr}
            {args[i] && args[i]}
        </React.Fragment>
    );
}

export default locFunction;


// WEBPACK FOOTER //
// ./src/locFunction.js